import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { CardHeader, IconButton, TextField, Tooltip } from "@material-ui/core";
import GuardianTrashIcon from "../Messaging/icons/GuardianTrash";
import GuardianCheckMarkIcon from "../Messaging/icons/GuardianCheckMark";
import * as noteManagementActions from "../../../actions/Management/noteManagementActions";
import { intl } from "../../../intl";
import MinimizeIcon from "@material-ui/icons/Minimize";
import { Rnd } from "react-rnd";

const useStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
  },
  root2: {
    width: 340,
    maxHeight: 520,
    height: "auto",
    zIndex: 1,
    marginTop: 16,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: 12,
  },
  conferenceContent: {
    paddingBottom: 4,
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },
  conferenceField: {
    height: "auto",
    backgroundColor: "transparent",
    border: 0,
    paddingLeft: 0,
    "& textarea": {
      maxHeight: 360,
      overflowY: "auto !important",
    },
  },
  textField: {
    height: "auto",
    backgroundColor: "transparent",
    border: 0,
    paddingLeft: 0,
  },
  pos: {
    marginBottom: 12,
  },
  cardActions: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
});

const NoteCardView = ({ note, draggable = true }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [noteContent, setNoteContent] = useState(note ? note.content : "");
  const [counter, setCounter] = useState(
    note.content ? note.content.length : 0
  );

  const isMinimized = useSelector((state) => state.noteManagement.isMinimized);
  const minimizedTitle = useSelector(
    (state) => state.noteManagement.minimizedTitle
  );
  const handleAddNote = () => {
    let body = {
      content: noteContent,
    };
    if (noteContent?.trim().length > 0)
      dispatch(noteManagementActions.createNote(body));
    if (draggable) dispatch(noteManagementActions.handleNewNote(false));
    else dispatch(noteManagementActions.handleNewConferenceNote(false));
  };

  useEffect(() => {
    if (minimizedTitle) {
      setNoteContent(minimizedTitle);
    }
  }, [minimizedTitle]);

  useEffect(() => {
    setCounter(noteContent?.length);
  }, [noteContent]);

  if (isMinimized) return null;
  return (
    <div style={{ zIndex: 21 }}>
      {draggable ? (
        <Rnd
          default={{
            x: 150,
            y: 205,
            width: 300,
            height: 300,
          }}
          dragHandleClassName={"dragMe"}
          minWidth={300}
          minHeight={300}
          bounds="window"
        >
          <Card className={classes.root} variant="outlined">
            <CardHeader
              style={{ cursor: "move" }}
              className={"dragMe"}
              title={intl.formatMessage({
                id: "notes.note",
                defaultMessage: "Note",
              })}
              action={
                <Tooltip
                  title={
                    isMinimized
                      ? intl.formatMessage({
                          id: "notes.maximize",
                          defaultMessage: "Maximize Note",
                        })
                      : intl.formatMessage({
                          id: "notes.minize",
                          defaultMessage: "Minimize Note",
                        })
                  }
                >
                  <MinimizeIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(noteManagementActions.minimizeNote(noteContent));
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              }
            />
            <CardContent>
              <TextField
                id="noteContent"
                className={classes.textField}
                rows={11}
                multiline
                autoFocus
                value={noteContent}
                InputProps={{
                  disableUnderline: true,
                }}
                inputProps={{ maxLength: 2000 }}
                onChange={(event) => {
                  const { value } = event.target;
                  setNoteContent(value);
                }}
              />
            </CardContent>
            <CardActions className={classes.cardActions}>
              <p style={{ color: "gray" }}>{counter} / 2000</p>
              <Tooltip
                title={intl.formatMessage({
                  id: "notes.save",
                  defaultMessage: "Save",
                })}
              >
                <IconButton onClick={handleAddNote}>
                  <GuardianCheckMarkIcon />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={intl.formatMessage({
                  id: "notes.delete",
                  defaultMessage: "Delete",
                })}
              >
                <IconButton
                  onClick={() => {
                    if (draggable)
                      dispatch(noteManagementActions.handleNewNote(false));
                    else
                      dispatch(
                        noteManagementActions.handleNewConferenceNote(false)
                      );
                  }}
                >
                  <GuardianTrashIcon />
                </IconButton>
              </Tooltip>
            </CardActions>
          </Card>
        </Rnd>
      ) : (
        <Card className={classes.root2} variant="outlined">
          <CardContent className={classes.conferenceContent}>
            <TextField
              id="noteContent"
              className={classes.conferenceField}
              rows={14}
              multiline
              autoFocus
              value={noteContent}
              InputProps={{
                disableUnderline: true,
              }}
              inputProps={{ maxLength: 2000 }}
              onChange={(event) => {
                const { value } = event.target;
                setNoteContent(value);
              }}
            />
          </CardContent>
          <CardActions style={{ justifyContent: "flex-end", paddingTop: 0 }}>
            <Tooltip
              title={intl.formatMessage({
                id: "notes.save",
                defaultMessage: "Save",
              })}
            >
              <IconButton onClick={handleAddNote}>
                <GuardianCheckMarkIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={intl.formatMessage({
                id: "notes.delete",
                defaultMessage: "Delete",
              })}
            >
              <IconButton
                onClick={() => {
                  if (draggable)
                    dispatch(noteManagementActions.handleNewNote(false));
                  else
                    dispatch(
                      noteManagementActions.handleNewConferenceNote(false)
                    );
                }}
              >
                <GuardianTrashIcon />
              </IconButton>
            </Tooltip>
          </CardActions>
        </Card>
      )}
    </div>
  );
};

export default NoteCardView;
